import * as React from 'react';
import { cn } from '../../lib/cn.js';

export interface KeyValueItem {
  label: string;
  /** null/undefined renders "Desconocido". */
  value: React.ReactNode | null | undefined;
  hint?: React.ReactNode;
}

export interface KeyValueListProps {
  items: readonly KeyValueItem[];
  columns?: 1 | 2;
  /** Inline label/value rows (label left) instead of stacked. */
  inline?: boolean;
  className?: string;
}

export const KeyValueList = React.forwardRef<HTMLDListElement, KeyValueListProps>(function KeyValueList({ items, columns = 1, inline, className }, ref) {
  return (
    <dl ref={ref} className={cn('grid gap-x-6 gap-y-3', columns === 2 && 'sm:grid-cols-2', className)}>
      {items.map((it) => (
        <div key={it.label} className={cn(inline ? 'flex items-baseline justify-between gap-3' : 'grid gap-0.5')}>
          <dt className="text-meta font-medium text-text-secondary">{it.label}</dt>
          <dd className={cn('min-w-0 text-body', inline && 'text-right')}>
            {it.value === null || it.value === undefined || it.value === '' ? (
              <span className="italic text-text-secondary">Desconocido</span>
            ) : (
              <span className="text-text-primary">{it.value}</span>
            )}
            {it.hint ? <span className="block text-meta text-text-secondary">{it.hint}</span> : null}
          </dd>
        </div>
      ))}
    </dl>
  );
});
